import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DataTableContext from 'src/components/DataTable/components/DataTableContext';
import PageCardLayout from 'src/components/PageCardLayout';
import { CardHeader, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Dashboard } from 'src/pages/Solutions/SolutionAssetHierarchy/solutionDashboard/components/Dashboard';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';

type Props = {
  item?: any;
  onClose?: () => void;
};

function SolutionDashboardViewModal({ item, onClose }: Props) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const handleDashboardClose: ModalCloseHandler = (event, reason) => {
    if (reason === ModalCloseReason.completeAction && onClose) {
      onClose();
    }
  };

  return (
    <DataTableContext>
      <CardHeader
        data-testid="solution-dashboard-header"
        title={
          <>
            <ArrowBackIcon
              sx={{ cursor: 'pointer' }}
              color="primary"
              fontSize="small"
              onClick={handleBackClick}
            />
            <Typography
              style={{
                marginTop: '-2rem',
                paddingLeft: '3.5rem',
                fontFamily: 'Stolzl',
                fontSize: '18px',
              }}
            >
              {`View Dashboard - ${item?.name || 'Dashboard'}`}
            </Typography>
          </>
        }
        sx={{
          boxShadow: '3px 3px 5px #E8E8E8',
          backgroundColor: '#fff',
          border: '0.1rem solid #E8E8E8',
        }}
      />
      <PageCardLayout>
        <Dashboard item={item} onClose={handleDashboardClose} />
      </PageCardLayout>
    </DataTableContext>
  );
}
export default SolutionDashboardViewModal;
